<template>
    <div>
        <li class="m_li" @mouseleave="onMouseOut($event)" @mouseenter="onMouseOver($event)">
            <a href="javascript:;" class="f" @click="user">
                <i class="iconfont icon-dingdandingdanchaxun1" style="color:#ffffff;font-size:22px;"></i>
            </a>
            <p class="r_av m_tr" :style="active">订单查询<em class="r_vt">◆</em></p>
        </li>
    </div>
</template>

<script>
export default{
    data(){
        return{
            active:"",
            name: '',
        }
    },
    mounted(){
        /*页面挂载获取保存的cookie值，渲染到页面上*/
        if(window.localStorage.getItem("user")){
            this.name = JSON.parse(window.localStorage.getItem("user")).username
        }
    },
    methods:{
        user(){
            //指定跳转地址
			if(this.name != ""){
				//指定跳转地址
				this.$router.push('/user_order')
			}else{
				this.$router.push('/login')
			}
		},
        onMouseOver($event){
            $event.currentTarget.className="m_li m_lion";
            this.active="opacity: 1; right: 35px; display: block;"
        },
        onMouseOut($event){
            $event.currentTarget.className="m_li";
            this.active="opacity: 0; right: 70px; display: none;"
        },
    },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/right-order.vue